if (!customElements.get('read-more-description')) {
  customElements.define(
    'read-more-description',
    class ReadMoreDescription extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-read-more-content]');
        this.button = this.querySelector('[data-read-more-button]');
        if (!this.content || !this.button) return;

        this.lines = parseInt(this.dataset.lines, 10) || 5;
        this.expanded = false;
        this.width = 0;

        this.onClick = this.toggle.bind(this);
        this.button.addEventListener('click', this.onClick);

        // Line wrapping only depends on width; also skips measuring while hidden (width 0)
        this.resizeObserver = new ResizeObserver((entries) => {
          const width = entries[0].contentRect.width;
          if (width === this.width) return;
          this.width = width;
          this.update();
        });
        this.resizeObserver.observe(this);

        // Web fonts swapping in can change the line count too
        if (document.fonts) document.fonts.ready.then(() => this.update());
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.button) this.button.removeEventListener('click', this.onClick);
      }

      update() {
        const clampHeight = this.getClampHeight();
        const isClamped = clampHeight !== null && !this.expanded;

        this.button.hidden = clampHeight === null;
        this.content.style.maxHeight = isClamped ? `${clampHeight}px` : '';
        this.classList.toggle('is-clamped', isClamped);
        this.classList.add('is-ready');
      }

      // Height showing exactly `this.lines` rendered lines, or null when the content is not longer than that.
      // Counts text line boxes, so headings, paragraphs and list items each count as the lines they render.
      getClampHeight() {
        const top = this.content.getBoundingClientRect().top;
        const walker = document.createTreeWalker(this.content, NodeFilter.SHOW_TEXT);
        const range = document.createRange();
        let count = 0;
        let lineBottom = -Infinity;

        while (walker.nextNode()) {
          range.selectNodeContents(walker.currentNode);
          for (const rect of range.getClientRects()) {
            if (!rect.width || !rect.height) continue;
            if (rect.top >= lineBottom - 1) {
              // First rect of a new line: cut halfway between the last visible line and this one
              if (count === this.lines) return Math.ceil((lineBottom + rect.top) / 2 - top);
              count++;
            }
            lineBottom = Math.max(lineBottom, rect.bottom);
          }
        }

        return null;
      }

      toggle() {
        this.expanded = !this.expanded;
        this.button.setAttribute('aria-expanded', this.expanded);
        this.button.textContent =this.expanded ? this.dataset.textLess : this.dataset.textMore;
        this.update();

        // Collapsing a long description can leave the button above the viewport
        if (!this.expanded && this.button.getBoundingClientRect().top < 0) {
          this.button.scrollIntoView({ block: 'center' });
        }
      }
    }
  );
}
